var r,e;function t(){return e?r:(e=1,r=(r,e=process.argv)=>{const t=r.startsWith("-")?"":1===r.length?"-":"--",n=e.indexOf(t+r),s=e.indexOf("--");return-1!==n&&(-1===s||n<s)})}export{t as __require};
